/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_EyebrowInputs */

const en_directory_external_directories_eyebrow = /** @type {(inputs: Directory_External_Directories_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submission Catalog`)
};

const zh_directory_external_directories_eyebrow = /** @type {(inputs: Directory_External_Directories_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交目录大全`)
};

/**
* | output |
* | --- |
* | "Submission Catalog" |
*
* @param {Directory_External_Directories_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_eyebrow = /** @type {((inputs?: Directory_External_Directories_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_eyebrow(inputs)
	return zh_directory_external_directories_eyebrow(inputs)
});
export { directory_external_directories_eyebrow as "directory.external_directories.eyebrow" }